/* eslint-disable react-hooks/exhaustive-deps */
import ICONS from "../../../../../assets/Icons";
import { GlobalConfiguration } from "../../../../../utils/configurationProvider";
import { formatAccountNumber } from "../../../../_utils/FormatAccountNumber";
import SVGComponent from "../../../../_utils/SVGComponent";
import DataActionField from "../../../../_utils/TransactionCommonComponents/DataActionField";

const InternalRecreateTxnStepSourceDestination = ({
  internalTransactionsDetailsData,
  refactorAccountDetail,
  refactorDestinationAccountDetail,
  setIsConfidential,
  refactorTransactionData,
  txnPayLoad,
  isConfidential,
  setAutoFill,
  config,
  handleDestinationAccountSelection,
  handleSourceAccountSelection,
}) => {
  return (
    <div className="flex flex-col Qsmd:justify-center Qsmd:flex-row gap-gap-md lg:gap-gap-xl Qsmd:my-margin-md h-screen bg-primary-bg Qsmd:bg-primary-card Qsmd:h-auto w-width-full fixed z-z-index-content Qsmd:relative top-top-base left-left-base mt-margin-base">
      <div className="h-mobile-create-header flex w-width-full bg-primary-nav Qsmd:hidden">
        <div className="p-padding-md">
          <div
            className="flex flex-shrink-0 cursor-pointer"
            onClick={() => {
              setAutoFill(false);
            }}
          >
            <SVGComponent
              url={ICONS?.ARROW_LEFT_WHITE}
              color="var(--text-primary)"
              height={"var(--icon-sm)"}
              width={"var(--icon-sm)"}
              alt="Arrow right"
            />
          </div>
        </div>
        <div className="flex flex-col w-width-full py-padding-sm">
          <div className="text-text-primary text-font-md">
            Create transaction
          </div>
          <p className=" text-text-primary text-font-xs font-semibold">
            Previous transaction details
          </p>
        </div>
      </div>

      <div className="flex flex-col gap-gap-md Qsmd:flex-1 w-width-full h-auto px-padding-md Qsmd:px-padding-base">
        <DataActionField
          label="Source Account"
          value={formatAccountNumber(
            refactorTransactionData?.owner_account_bank_acc_no,
          )}
          icon={
            refactorAccountDetail
              ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
              : ICONS?.AUTOFILL_WHITE
          }
          hoverEnabled={!refactorAccountDetail}
          onClick={handleSourceAccountSelection}
        />

        <DataActionField
          label="Create As Confidential Transaction"
          value={
            internalTransactionsDetailsData?.transaction?.[0]
              ?.confidential_transaction === "Y"
              ? "Confidential transaction enabled"
              : "Confidential transaction disabled"
          }
          isActive={isConfidential === config}
          icon={
            isConfidential === config
              ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
              : ICONS?.AUTOFILL_WHITE
          }
          hoverEnabled={isConfidential !== config}
          onClick={() => {
            if (
              internalTransactionsDetailsData?.transaction?.[
                GlobalConfiguration?.lengthCheckZero
              ]?.confidential_transaction === "Y"
            ) {
              setIsConfidential(true);
            } else if (
              internalTransactionsDetailsData?.transaction?.[
                GlobalConfiguration?.lengthCheckZero
              ]?.confidential_transaction === "N"
            ) {
              setIsConfidential(false);
            }
          }}
        />
      </div>

      <div className="flex flex-col gap-gap-md Qsmd:flex-1 w-width-full h-auto px-padding-md Qsmd:px-padding-base">
        <DataActionField
          label="Destination Account"
          value={formatAccountNumber(
            refactorTransactionData?.internal_account_bank_acc_no,
          )}
          icon={
            refactorDestinationAccountDetail
              ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
              : ICONS?.AUTOFILL_WHITE
          }
          hoverEnabled={!refactorDestinationAccountDetail}
          onClick={handleDestinationAccountSelection}
          disabled={txnPayLoad?.ownerId === null}
        />
      </div>
    </div>
  );
};

export default InternalRecreateTxnStepSourceDestination;
